import React from 'react';
import { Rec } from '../../component';
import { Link } from 'dva/router';
import styles from './index.css';

export default class NewUpdateBook extends React.Component {
	render() {
		const {updataBook} = this.props
		return (
			<div className={styles.newupdate_wrap}>
				<h3 className={styles.newupdate_title}>最近更新</h3>
                <div>
                    <div style={{display:'flex',flexWrap:'wrap',justifyContent:'space-between',background:'#f9f9f9',lineHeight:'54px'}}>
                        <div style={{width:'110px',fontSize:'16px',color:'#666',textAlign:'left'}}>分类</div>
                        <div style={{margin:'0 20px',flex:1,fontSize:'16px',color:'#666',textAlign:'left'}}>书名/更新章节</div>
                        <div style={{width:'180px',fontSize:'16px',color:'#666',paddingLeft:'19px'}}>作者</div> 
                        <div style={{width:'110px',fontSize:'16px',color:'#666'}}>更新时间</div>           
                    </div>
    				<Rec.ListRec
                        template='brief_13'
                        width={1000}
                        data={updataBook.slice(0,10).map((book,idx) => ({
                            idx:idx,
                            novel_id: book.novel_id, 
                            name: book.name,
                            tag_name: book.tag_name,
                            author_name: book.author_name,
                            is_vip:book.is_vip,
                            title:book.newest_paragraph['title'],
                            update_time:book.newest_paragraph['update_time'],
                        }))}/>
                    <div className={styles.see_more} style={{background:updataBook.length%2===0?'':'#f9f9f9'}}>
                        <Link to={'/category'}>
                            <span>查看更多</span>
                        </Link>
                    </div>
                </div>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/layout/home/newupdate.js